<template>
  <div>
    <h1>Manage Client Documents</h1>
    <div class="mt-5">
      <client-documents-table :table-items="clientDocuments" @update="clientDocuments = $event" />
    </div>
  </div>
</template>

<script>
import ClientDocumentsTable from '@/components/manageClientDocuments/ClientDocumentsTable'
import { mapActions } from 'vuex'

export default {
  name: 'manage-client-documents',
  components: {
    ClientDocumentsTable
  },
  data() {
    return {
      clientDocuments: []
    }
  },
  created() {
    this.getClientDocuments().then(e => this.clientDocuments = e.data, () => {})
  },
  methods: {
    ...mapActions('manageClientDocuments', ['getClientDocuments'])
  }
}
</script>
